// Version of the SearchApp, change this if you want to expire the search-app.js asset
const SearchAppVersion = '1.1';

console.log('SearchApp version', SearchAppVersion); // don't remove this line

require('search-app/main');
